import styled from "@emotion/styled";

import EntityItem from "metabase/components/EntityItem";

export const EntityItemMenu = styled(EntityItem.Menu)`
  color: var(--mb-color-text-medium);
`;
